<template>
  <p>change subscriptions page</p>
</template>

<script>
export default {};
</script>

<style>
</style>